import React from "react";
import { Outlet } from "react-router-dom";

const SiteLayout = () => {


    return (
        <>
            <Outlet />
        </>
    );
}

export default SiteLayout;